import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { BaseResponse } from '../../models/base-response';
import { HttpErrorResponse } from '@angular/common/http';
import { KeycloakConfig } from '../../keycloak/keycloak-config';
import { Helpers } from '../../helpers';

@Injectable({
	providedIn: 'root'
})
export class HttpUtilsService {

	constructor() { }

	/**
	 * This function returns an Observable that resolves to an empty Headers object wrapped in a
	 * Promise.
	 * @returns An Observable that emits the result of a Promise that resolves to a Headers object.
	 */
	getHTTPHeadersAsyncMe(): Observable<any> {
		return from(new Promise(resolve => {
			try {
                let headers: Headers = new Headers();
                return resolve(headers);
			} catch (err) {
                console.error(err);
				return throwError(err);
			}
		}));
	}

	getHTTPHeadersAsync(): Observable<any> {
		return from(new Promise(resolve => {
			try {
                let headers: Headers = new Headers();
				headers.append("Accept","*/*")
				headers.append("X-Consumer-Key",localStorage.getItem('tenant')!)
				headers.append("Content-Type","application/json")
				headers.append("Authorization",`Bearer ${Helpers.getToken()}`)
                return resolve(headers);
			} catch (err) {
                console.error(err);
				return throwError(err);
			}
		}));
	}


	handleError(response: BaseResponse): HttpErrorResponse {
		const err: any = {
			error: response.errorMessage,
			status: response.errorCode,
			statusText: response.errorMessage
		};
		const error: HttpErrorResponse = new HttpErrorResponse(err);

		if (response.errorCode === 401) { // Unauthorized
			KeycloakConfig.keycloakLogout()
		}
		throw error;
	}
	 /**
	 * The function calls the KeycloakConfig method to log out the user.
	 */
	 logout() {
        KeycloakConfig.keycloakLogout()
    }
}
